import React, { useEffect, useState } from 'react';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import useAuth from "hooks/useAuth"
import 'react-phone-number-input/style.css'

import api from "assets/services/api";


function ModalAddAnalytical(props) {

    const [br, setBR] = useState(false);

    const [code, setCode] = useState();
    const [description, setDescription] = useState();
    const [subsynthetics, setSubsynthetics] = useState([]);
    const [id_subsynthetic, setId_subsynthetic] = useState();
    const { storageId } = useAuth();
    const [controlSnack, setControlSnack] = useState(false);


    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        if (controlSnack) showNotification("br")
    }, [controlSnack]);

    useEffect(() => {
        getAllSynthetics();
    }, [])

    async function handleAddAnalytical(e) {
        e.preventDefault();
        const response = await api.post('/analytical', {
            code: code,
            description: description,
            id_admin: storageId,
            id_subsynthetic: id_subsynthetic
        });
        if (response.data.error) {
            return alert(response.data.error);
        }
        props.getAllAnalytical();
        props.onHide();
    }

    async function getAllSynthetics() {
        const response = await api.get('/subsynthetic/all?id_admin=' + storageId)
        if (response.data.lenght !== 0) {
            setSubsynthetics(response.data);
            if (response.data) {
                setId_subsynthetic(response.data[0].id)
            }
        }

    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Adicionar analítco
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleAddAnalytical}>
                <Modal.Body>
                    <Form.Row>
                        <Form.Group as={Col} xs={2} controlId="formGridName">
                            <Form.Label>Código</Form.Label>
                            <Form.Control onChange={event => setCode(event.target.value)} type="text" placeholder="Código do analítico" />
                        </Form.Group>
                        <Form.Group as={Col} xs={10} controlId="formGridName">
                            <Form.Label>Descrição</Form.Label>
                            <Form.Control onChange={event => setDescription(event.target.value)} type="text" placeholder="Nome do analítico" />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridAlternativeRoute">
                            <Form.Label>Sub-Sintéticos</Form.Label>
                            <Form.Control onChange={event => setId_subsynthetic(event.target.value)} as="select" value={id_subsynthetic}>
                                {subsynthetics.map(synthetic => (
                                    <option key={String(synthetic.id)} value={synthetic.id}>{synthetic.code} - {synthetic.description}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Form.Row>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button color="success" type="submit">
                            Adicionar analítico
                        </Button>
                        <Snackbar
                            place="br"
                            color="success"
                            icon={AddAlert}
                            message="analítco adicionado com sucesso"
                            open={br}
                            closeNotification={() => setBR(false)}
                            close
                        />
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default ModalAddAnalytical;